import type { RoutePoint } from '@/pages/Business/pages/Shippings/models';

const isBasePoint = (routePoint: RoutePoint): boolean =>
  routePoint.tag === 'BASE' || routePoint.tag === 'BASE_POINT';

const getOrder = (routePoint: RoutePoint): number =>
  typeof routePoint.order === 'number' && !Number.isNaN(routePoint.order)
    ? routePoint.order
    : 999_999;

export function sortRoutePointsByServerOrder(
  points: RoutePoint[]
): RoutePoint[] {
  if (points.length <= 1) return points;

  const bases = points.filter(isBasePoint);
  const nonBase = points.filter((routePoint) => !isBasePoint(routePoint));
  const sortedVisits = [...nonBase].sort((firstPoint, secondPoint) =>
    getOrder(firstPoint) - getOrder(secondPoint)
  );

  return [...bases, ...sortedVisits];
}
